export default () => ({
  events: [
    // {
    //   id: 300001,
    //   eventDateBegin: '2018-11-16T17:00:00.000Z',
    //   eventDateEnd: '2018-11-16T21:00:00.000Z',
    //   eventName: 'Beaujolais-Primeur-Party',
    // },
    // {
    //   id: 300002,
    //   eventDateBegin: '2019-01-26T09:00:00.000Z',
    //   eventDateEnd: '2019-01-26T15:00:00.000Z',
    //   eventName: 'Dankeschönverkauf (20% Rabatt)',
    // },
    // {
    //   id: 300003,
    //   eventDateBegin: '2019-03-29T17:00:00.000Z',
    //   eventDateEnd: '2019-03-29T21:00:00.000Z',
    //   eventName: 'Frühlingsfest',
    // },
    // {
    //   id: 300004,
    //   eventDateBegin: '2019-05-24T16:00:00.000Z',
    //   eventDateEnd: '2019-05-24T20:00:00.000Z',
    //   eventName: 'Sommerfest',
    // },
    // {
    //   id: 300005,
    //   eventDateBegin: '2019-09-06T16:00:00.000Z',
    //   eventDateEnd: '2019-09-06T20:00:00.000Z',
    //   eventName: 'Federweißen-Fete',
    // },
    // {
    //   id: 300006,
    //   eventDateBegin: '2019-09-20T16:00:00.000Z',
    //   eventDateEnd: '2019-09-20T20:00:00.000Z',
    //   eventName: 'Die Nacht der guten Weine',
    // },
    // {
    //   id: 300007,
    //   eventDateBegin: '2019-11-22T17:00:00.000Z',
    //   eventDateEnd: '2019-11-22T21:00:00.000Z',
    //   eventName: 'Beaujolais-Primeur-Party',
    // },
    // {
    //   id: 300008,
    //   eventDateBegin: '2020-01-25T09:00:00.000Z',
    //   eventDateEnd: '2020-01-25T15:00:00.000Z',
    //   eventName: 'Dankeschönverkauf (20% Rabatt)',
    // },
    // {
    //   id: 300009,
    //   eventDateBegin: '2020-03-27T17:00:00.000Z',
    //   eventDateEnd: '2020-03-27T21:00:00.000Z',
    //   eventName: 'Frühlingsfest',
    //   canceled: true,
    // },
    // {
    //   id: 300010,
    //   eventDateBegin: '2020-06-05T16:00:00.000Z',
    //   eventDateEnd: '2020-06-05T20:00:00.000Z',
    //   eventName: 'Sommerfest',
    //   canceled: true,
    // },
    // {
    //   id: 300011,
    //   eventDateBegin: '2020-09-04T16:00:00.000Z',
    //   eventDateEnd: '2020-09-04T20:00:00.000Z',
    //   eventName: 'Federweißen-Fete',
    //   canceled: true,
    // },
    // {
    //   id: 300012,
    //   eventDateBegin: '2020-09-18T16:00:00.000Z',
    //   eventDateEnd: '2020-09-18T20:00:00.000Z',
    //   eventName: 'Die Nacht der guten Weine',
    //   canceled: true,
    // },
    // {
    //   id: 300013,
    //   eventDateBegin: '2020-11-20T17:00:00.000Z',
    //   eventDateEnd: '2020-11-20T21:00:00.000Z',
    //   eventName: 'Beaujolais-Primeur-Party',
    //   canceled: true,
    // },

    {
      id: 300014,
      eventDateBegin: '2021-02-13T09:00:00.000Z',
      eventDateEnd: '2021-02-13T15:00:00.000Z',
      eventName: 'Dankeschönverkauf',
      canceled: false,
    },
    {
      id: 300015,
      eventDateBegin: '2021-04-16T17:00:00.000Z',
      eventDateEnd: '2021-04-16T21:00:00.000Z',
      eventName: 'Frühlingsfest',
      // canceled: true,
    },
    {
      id: 300016,
      eventDateBegin: '2021-06-18T16:00:00.000Z',
      eventDateEnd: '2021-06-18T20:00:00.000Z',
      eventName: 'Sommerfest',
      // canceled: true,
    },
    {
      id: 300017,
      eventDateBegin: '2021-09-03T16:00:00.000Z',
      eventDateEnd: '2021-09-03T20:00:00.000Z',
      eventName: 'Federweißen-Fete',
      // canceled: true,
    },
    {
      id: 300018,
      eventDateBegin: '2021-09-17T16:00:00.000Z',
      eventDateEnd: '2021-09-17T20:00:00.000Z',
      eventName: 'Die Nacht der guten Weine',
      // canceled: true,
    },
    {
      id: 300019,
      eventDateBegin: '2021-11-18T17:00:00.000Z',
      eventDateEnd: '2021-11-18T21:00:00.000Z',
      eventName: 'Beaujolais-Primeur-Party',
      // canceled: true,
    },
  ],
})
